const React = require('react');

const Utilities = require('./Utilities.jsx');

function GoogleFontImport(props) {
    const config = props.config || {};
    if (!config.Fonts || !config.Fonts.LinkHref || config.Fonts.LinkHref.length == 0) {
        return null;
    }
    return (
        <>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link rel="stylesheet" href={config.Fonts.LinkHref} />
        </>
    )
}

function Legacy(props) {
    const data = props.data || {};
    const styleguide = data.Styleguide || {};

    const headerFont = styleguide.HeaderFont;
    let headerStyle;
    if (headerFont && !Utilities.isNullOrWhitespace(headerFont.WebsiteUrl)) {
        if (headerFont.Hosted) {
            const html = `
                @font-face {
                    font-family: '${headerFont.Name}';
                    src: url(${headerFont.WebsiteUrl}) format('truetype')
                }`;
            headerStyle = <style dangerouslySetInnerHTML={{ __html: html }} />;
        } else if (props.type == 1) {
            // PDF
            const html = `@import url('${headerFont.WebsiteUrl}');`
            headerStyle = <style dangerouslySetInnerHTML={{ __html: html }} />;
        } else {
            headerStyle = <link href={headerFont.WebsiteUrl} rel="stylesheet" type="text/css" />;
        }
    }
    const bodyFont = styleguide.BodyFont;
    let bodyStyle;
    if (bodyFont && !Utilities.isNullOrWhitespace(bodyFont.WebsiteUrl)) {
        if (bodyFont.Hosted) {
            const html = `
                @font-face {
                    font-family: '${bodyFont.Name}';
                    src: url(${bodyFont.WebsiteUrl}) format('truetype')
                }`;
            bodyStyle = <style dangerouslySetInnerHTML={{ __html: html }} />;
        } else if (props.type == 1) {
            // PDF
            const html = `@import url('${bodyFont.WebsiteUrl}');`
            bodyStyle = <style dangerouslySetInnerHTML={{ __html: html }} />;
        } else {
            bodyStyle = <link href={bodyFont.WebsiteUrl} rel="stylesheet" type="text/css" />;
        }
    }
    return (
        <React.Fragment>
            {headerStyle}
            {bodyStyle}
        </React.Fragment>
    )
}

module.exports = {
    GoogleFontImport,
    Legacy
};